import {endForm, recordDelete} from '../../../services/form/form';
import {Form, formsStore} from '../../../stores/Form';
import {fetchStepsFormByStepId, getEoyLog} from './wizardLog';
import {clearEOYRemindersStoreData} from './reminders';

// it's an util function to clear the wizard log
// IMPORTANT: this function is not used in the codebase
// for development purposes only

export const clearWizardLog = async () => {
    clearEOYRemindersStoreData();
    const eoyLogForm: Form = await getEoyLog();
    const subForm = await fetchStepsFormByStepId(eoyLogForm, '*');
    if (subForm) {
        for (let i = 0; i < subForm.records.length; i++) {
            const screen = formsStore.getScreenBySession(eoyLogForm.session);
            await recordDelete(eoyLogForm.session, subForm.records[i].keys);
            if (i === subForm.records.length - 1) {
                await endForm(subForm.session);
                await screen.recordDeleteAction(eoyLogForm.currentRecord);
            }
        }
    }
};
